import React from 'react';
import { I_DirectionList } from '@Redux/search/interfaces';
import FlightList from './FlightList';
import styles from '../styles.module.scss';

interface I_Props {
    directions: I_DirectionList[];
}

const DirectionList: React.FC<I_Props> = ({ directions }) => {
    return (
        <>
            {directions.map((direction: I_DirectionList, i: number) => (
                <div key={i} className={styles['flights__sub']}>
                    <h4>{direction.Name}</h4>
                    <FlightList flights={direction.FlightList} isBack={direction.Name === '回程'} />
                </div>
            ))}
        </>
    );
};

export default DirectionList;
